import { render, staticRenderFns } from "./BenefitItem.vue?vue&type=template&id=7da8bd9e"
import script from "./BenefitItem.vue?vue&type=script&lang=js"
export * from "./BenefitItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports